const styles = theme => {
  return {
    root: {
      width: 'calc(100% - 80px)',
      margin: '10px 20px 10px 40px'
    },
    row: { borderBottom: '1px solid #EDEDED', height: '50px' },
    severity: {
      width: '100px',
      margin: '5px 10px'
    },
    cell: { width: '250px' },
    loaderOverlay: {
      top: '0px',
      left: '0px',
      width: '100%',
      height: '100%',
      background: '#FFF',
      opacity: '.5',
      zIndex: 100,
      display: 'flex',
      paddingLeft: '40px',
      alignItems: 'center'
    },
    noFeatures: {
      height: '60px',
      display: 'flex',
      alignItems: 'center',
      paddingLeft: '40px'
    }
  };
};

export default styles;
